var map = {
	"./acai.svg": "4b02",
	"./agua.svg": "92e0",
	"./arabe.svg": "69c7",
	"./bebidas.svg": "4a00",
	"./bolo.svg": "12cf",
	"./cafe.svg": "ba6d",
	"./camarao.svg": "0d25",
	"./cardapio.svg": "5d2b",
	"./carne.svg": "dad9",
	"./cervejas.svg": "e85d",
	"./chope.svg": "a319",
	"./churrasco.svg": "e2df",
	"./combos.svg": "f2a2",
	"./destaques.svg": "5781",
	"./frango.svg": "d59b",
	"./hamburguer.svg": "d9b9",
	"./hot-dog.svg": "b820",
	"./kids.svg": "bf68",
	"./massas.svg": "0c3f",
	"./pao.svg": "cac7",
	"./peixe.svg": "049e",
	"./pizza.svg": "8248",
	"./porcoes.svg": "fc2f",
	"./promocoes.svg": "a8c9",
	"./refrigerante.svg": "80ed",
	"./salada.svg": "2ce8",
	"./sanduiche.svg": "204c",
	"./sobremesas.svg": "0455",
	"./sopa.svg": "fa8f",
	"./sorvete.svg": "4e9b",
	"./sucos.svg": "49db",
	"./sushi.svg": "75b9",
	"./tacos.svg": "74ef",
	"./vegano.svg": "c42e",
	"./vinho.svg": "1ec7"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "cb01";